import React, { Suspense } from "react";
import { useRouter } from "next/router";

import TopBar from "@urbanpiper-engineering/meraki-components/dist/Organisms/TopBar";

import screenHelper from "../../external/helpers/screenHelper";
import configSelector from "../../external/configSelector";
import checkLightOrDark from "../../external/helpers/checkLightOrDark";
import colorConstants from "../../constants/colors.json";
import MerakiSDK from "@urbanpiper-engineering/meraki-sdk";
import { UserState } from "@urbanpiper-engineering/meraki-sdk/dist/esm/user/states/user.state";
import useLanguage from "../../hooks/useLanguage.hook";

function TopBarWrapper({
  supportedLanguages,
  isMobileView,
  theme,
}: {
  supportedLanguages?: string[];
  isMobileView?: boolean;
  theme: string;
}) {
  const [openDialog, setOpenDialog] = React.useState(false);

  const useUserState = MerakiSDK.getUserState().hook();
  const updateLocalLanguage = useLanguage();

  const router = useRouter();
  const isCheckoutScreen = screenHelper.isCheckoutPage(router.pathname);
  const topbarConfig = configSelector.getGlobalComponent({ name: `topbar` });
  const topbarBackgroundColor =
    topbarConfig?.customizations?.backgroundColor || "#f1f1f1";
  const lightOrDark = checkLightOrDark(topbarBackgroundColor);
  const topbarColors =
    lightOrDark === "light"
      ? colorConstants?.colors?.header?.light
      : colorConstants?.colors?.header?.dark;

  const activeLanguageInState = useUserState(
    (state: typeof UserState) => state.language,
  );

  if (isCheckoutScreen || !topbarConfig.customizations.enabled) {
    return null;
  }

  const supportedLanguagesArr = supportedLanguages?.map((lang: string) => ({
    code: lang,
    name: lang.toUpperCase(),
  }));

  return (
    <TopBar
      theme={theme}
      onLanguageChange={updateLocalLanguage}
      isMobile={isMobileView}
      supportedLanguages={supportedLanguagesArr}
      activeLanguage={activeLanguageInState}
      contactUsTitle={topbarConfig?.customizations?.rightLink?.title}
      contactUs={topbarConfig?.customizations?.rightLink?.link}
      downloadAppTitle={topbarConfig?.customizations?.leftLink?.title}
      appleStoreLink={topbarConfig?.customizations?.leftLink?.iOSAppLink}
      playStoreLink={topbarConfig?.customizations?.leftLink?.androidAppLink}
      themeColors={{
        backgroundColor: topbarBackgroundColor,
        textColor: topbarColors.textColor,
        iconColor: topbarColors.iconColor,
      }}
    />
  );
}

export default TopBarWrapper;
